<div class="submenu-complex-left">
    <nav class="nav overflow-y-hidden">
        <div class="d-flex flex-column gap-3 w-100 h-100">
            <div class="col-auto h-100 ms-3 mb-2">
                <list
                    id="room-list"
                    [clippedBody]="false"
                    [clippedSearch]="true"
                    [allowMultiSelect]="data().allowMultiSelect()"
                    (selectedEntity)="data().select($event)"
                    [filterEntities]="roomsFilter.coreSignal"
                    [entities]="filteredRooms()"
                    [template]="roomNodeTemplate"></list>
            </div>
        </div>
    </nav>
</div>

<ng-template
    #roomNodeTemplate
    let-securableNode="item">
        <item-small-generic                 
        class="font-5 p-1 py-2 b-bottom"
        [ngClass]="{ 'text-faded': !securableNode['isHovering'] }"                                                                       
        (mouseenter)="securableNode['isHovering'] = true" 
        (mouseleave)="securableNode['isHovering'] = false"                                        
        isSelectable="true"
        [currentItem]="securableNode"
        [template]="roomTemplate"/>
</ng-template>

<ng-template
    #roomTemplate    
    let-securable="item">
        <presenter [allowFallback]="true"  class="room-item"
            [data]="securable.value" /> 
</ng-template>

